import { IStoreState, IMatch } from '@zmedia/bm-soccer-ui/interface';

export const matchLiveSelector = (state: IStoreState): IMatch[] => state.match.items || [];
export const isUpdateMatchSelector = (state: IStoreState): boolean => state.match.shouldUpdate;
export const currentMatchLiveSelector = (state: IStoreState): IMatch | undefined => state.match.currentItem;
